import { useRef, useCallback } from 'react'

const DRAG_THRESHOLD = 6

// Некоторые тачпады/оверлеи эмулируют одноточечную мышь и не шлют нативных
// touch/scroll-жестов. Для pointerType 'mouse' скроллим контейнер вручную
// перетаскиванием; настоящий touch (pointerType 'touch') не трогаем —
// там нативный скролл ОС уже работает.
//
// Слушатели move/up вешаются на window, а не через setPointerCapture: capture
// ретаргетит все последующие события на контейнер, из-за чего обычный клик по
// кнопке внутри списка (без какого-либо перетаскивания) вообще переставал
// доходить до этой кнопки.
export default function useDragScroll() {
    const state = useRef({ dragging: false, moved: false, startX: 0, startY: 0, scrollLeft: 0, scrollTop: 0, el: null })

    const onPointerMove = useCallback((e) => {
        const s = state.current
        if (!s.dragging) return
        const dx = e.clientX - s.startX
        const dy = e.clientY - s.startY
        if (!s.moved && Math.hypot(dx, dy) > DRAG_THRESHOLD) s.moved = true
        if (s.moved) {
            s.el.scrollLeft = s.scrollLeft - dx
            s.el.scrollTop = s.scrollTop - dy
        }
    }, [])

    const onPointerUp = useCallback(() => {
        const s = state.current
        window.removeEventListener('pointermove', onPointerMove)
        window.removeEventListener('pointerup', onPointerUp)
        if (!s.dragging) return
        s.dragging = false
        if (s.moved) {
            // Гасим click, который браузер шлёт после отпускания в конце
            // реального перетаскивания, чтобы оно не срабатывало как нажатие
            // на кнопку под курсором. Снимаем листенер сразу же после текущего
            // тика, если click вообще не случился, чтобы не проглотить
            // следующий, никак не связанный клик.
            const suppressClick = (ev) => {
                ev.stopPropagation()
                ev.preventDefault()
            }
            window.addEventListener('click', suppressClick, { capture: true, once: true })
            setTimeout(() => window.removeEventListener('click', suppressClick, { capture: true }), 0)
        }
    }, [onPointerMove])

    const onPointerDown = useCallback((e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return
        const el = e.currentTarget
        state.current = {
            dragging: true,
            moved: false,
            startX: e.clientX,
            startY: e.clientY,
            scrollLeft: el.scrollLeft,
            scrollTop: el.scrollTop,
            el
        }
        window.addEventListener('pointermove', onPointerMove)
        window.addEventListener('pointerup', onPointerUp)
    }, [onPointerMove, onPointerUp])

    return { onPointerDown }
}
